import React from 'react';
import '../../styles/onboardingFlow/onboardingComponents/integrationQuestionSection.scss';
import QuestionCard from './QuestionCard';

type PromptDef = {
  platform_name: string;
  type: 'A' | 'B' | 'C';
  prompt: string;
};

type Props = {
  platformName: string;
  logo?: string;
  prompts: PromptDef[];
  isExpanded: boolean;
  onToggle: () => void;
  onQuestionSelect: (prompt: PromptDef) => void;
  selectedKey: string | null;
  isSubmitting: boolean;
};

const IntegrationQuestionSection: React.FC<Props> = ({
  platformName,
  logo,
  prompts,
  isExpanded,
  onToggle,
  onQuestionSelect,
  selectedKey,
  isSubmitting,
}) => {
  return (
    <div className='integrationQuestionSection'>
      <div
        className='integrationQuestionSection__header'
        onClick={onToggle}
        role='button'
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onToggle();
          }
        }}
        onMouseDown={(e) => {
          e.preventDefault();
        }}
      >
        <div className='integrationQuestionSection__header-left'>
          {logo && (
            <div className='integrationQuestionSection__icon'>
              <img src={logo} alt={platformName} />
            </div>
          )}
          <span className='integrationQuestionSection__name'>
            {platformName}
          </span>
        </div>
        <div
          className={`integrationQuestionSection__chevron ${
            isExpanded ? 'integrationQuestionSection__chevron--expanded' : ''
          }`}
        >
          <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M5 7.5L10 12.5L15 7.5'
              stroke='#667085'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </div>
      </div>

      {isExpanded && (
        <div className='integrationQuestionSection__content'>
          {prompts.map((prompt) => {
            const key = `${prompt.platform_name}-${prompt.type}`;
            return (
              <QuestionCard
                key={key}
                prompt={prompt.prompt}
                isSelected={selectedKey === key}
                isSubmitting={isSubmitting}
                onClick={() => onQuestionSelect(prompt)}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default IntegrationQuestionSection;
